var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ui-click-outside", { attrs: { do: _vm.hide } }, [
    _c(
      "div",
      {
        staticClass:
          "ds-panel ds-panel--space_xs ds-panel--space_md-xl relative"
      },
      [
        _c(
          "div",
          { staticClass: "ds-panel__element ds-panel__element--offset_full" },
          [
            _vm._t("inputview", null, {
              keyupEvent: _vm.dynamicSearch,
              keydownEvent: _vm.getFocus,
              goToSearch: _vm.goToSearch,
              reset: _vm.hide,
              activated: _vm.activated,
              show: _vm.show,
              activeSearch: _vm.activeSearch
            }),
            _c(
              "div",
              { staticClass: "seacrh-result-wrapper" },
              [
                _vm.load
                  ? _c("div", { staticClass: "form-load" }, [_c("loading")], 1)
                  : _vm._e(),
                _c("transition-group", { attrs: { name: "slidedown" } }, [
                  _vm.isAvailable(Object.keys(_vm.results)) && _vm.show
                    ? _c(
                        "div",
                        { key: "results", staticClass: "search-results" },
                        [
                          _c(
                            "div",
                            { staticClass: "list-search" },
                            [
                              _c("p", { staticClass: "list-search__preview" }, [
                                _vm._v(
                                  _vm._s(_vm._("оберіть тему зі списку нижче"))
                                )
                              ]),
                              _vm._l(_vm.results, function(val, key) {
                                return [
                                  _vm._l(val, function(item) {
                                    return [
                                      _c(key, {
                                        tag: "component",
                                        attrs: {
                                          item: item,
                                          fn: _vm.findValueAndHighlightTerm,
                                          fn_html: _vm.highlightTerm,
                                          localsearch: _vm.localsearch,
                                          trunc: _vm.truncateHtml
                                        }
                                      })
                                    ]
                                  })
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e(),
                  Object.keys(_vm.results).length &&
                  !_vm.isAvailable(Object.keys(_vm.results)) &&
                  _vm.show
                    ? _c(
                        "div",
                        {
                          key: "withoutresults",
                          staticClass: "search-results"
                        },
                        [
                          _c("div", { staticClass: "list-search" }, [
                            _c("p", { staticClass: "list-search__preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._(
                                    "По вашему поисковому запросу ничего не найдено"
                                  )
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2eddc4f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eddc4f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/search/Controller.vue
// module id = 229
// module chunks = 4